module.exports = __webpack_public_path__ + "static/konya-furkan-acar-mimar-bc90cf28d8351af78826caea82235195.jpg";